import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { isTcsOrFlightLogUrl } from '../app.config';
import { AuthStateService } from '../shared/authentication/auth-state.service';
import { AuthProxyService } from '../shared/authentication/auth-proxy.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private readonly _unauthorized = new Subject<void>();
  constructor(private _authState: AuthStateService, authProxy: AuthProxyService) {
    this._unauthorized.pipe().subscribe(() => {
      authProxy.login({ redirectUrl: window.location.href });
    });
  }
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this._authState.accessToken$.pipe(
      take(1),
      switchMap((token) => {
        if (token != null && isTcsOrFlightLogUrl(req.url)) {
          req = req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + token,
            },
          });
        }
        return next.handle(req);
      }),
      catchError((err) => {
        if (
          isTcsOrFlightLogUrl(req.url) &&
          err instanceof HttpErrorResponse &&
          err.status === 401
        ) {
          this._unauthorized.next();
        }
        return throwError(err);
      }),
    );
  }
}
